const ColorStore = {
    "#00a389": "#e0f4f1",
    "#2073C0": "#e1ebf5",
    "#a300a3": "#f5e1f5",
    "#a30036": "#f5e1e8",
    "#e64b00": "#f5e8e1",
    "#26a300": "#e6f5e1",
    "#000000" : "#e6e6e6",
}

export default ColorStore;

// 170° (<-->), 100%, 64%
// 171° (<-->), 8%, 96%